/**
 * Санитизация HTML для предотвращения XSS атак
 * Удаляет все HTML теги и опасные символы
 */
export function sanitizeHtml(text) {
  if (!text) return '';
  
  // Создаем временный элемент для декодирования HTML entities
  const temp = document.createElement('div');
  temp.textContent = text;
  
  return temp.innerHTML;
}

/**
 * Санитизация HTML с сохранением базового форматирования
 * Разрешает только безопасные теги: <b>, <i>, <u>, <br>
 */
export function sanitizeHtmlBasic(text) {
  if (!text) return '';
  
  // Список разрешенных тегов
  const allowedTags = ['b', 'i', 'u', 'br', 'strong', 'em'];
  
  // Экранируем все HTML
  const temp = document.createElement('div');
  temp.textContent = text;
  let sanitized = temp.innerHTML;
  
  // Возвращаем разрешенные теги
  allowedTags.forEach(tag => {
    const openRegex = new RegExp(`&lt;${tag}&gt;`, 'gi');
    const closeRegex = new RegExp(`&lt;/${tag}&gt;`, 'gi');
    sanitized = sanitized.replace(openRegex, `<${tag}>`);
    sanitized = sanitized.replace(closeRegex, `</${tag}>`);
  });
  
  return sanitized;
}

/**
 * Санитизация для результатов поиска
 * Разрешает только <span> с классом для подсветки
 */
export function sanitizeSearchResult(text, searchTerm) {
  if (!text || !searchTerm) return '';
  
  // Сначала экранируем весь HTML
  const temp = document.createElement('div');
  temp.textContent = text;
  let sanitized = temp.innerHTML;
  
  // Экранируем поисковый термин для использования в regex
  const escapedTerm = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  
  // Подсвечиваем найденные совпадения безопасным способом
  const regex = new RegExp(`(${escapedTerm})`, 'gi');
  sanitized = sanitized.replace(regex, '<span class="yel">$1</span>');
  
  return sanitized;
}
